// ============================================================
// 站点级配置（网页版全局）
// ============================================================

export const SITE_CONFIG = {
  // 小程序码图片地址：部署「真实小程序码」后填入（建议放到 public/images/mini-program-qr.png）
  // 留空时前端用占位二维码（内容为 miniProgramScheme，仅供视觉示意，不可真实打开）
  miniProgramQr: '',

  // 占位 scheme：微信小程序 URL Scheme（需后端申请正式 scheme 后替换，用于占位码渲染）
  miniProgramScheme: 'weixin://dl/business/?t=AI_PEIPIN_XIAOHULI'
}
